import { DEFAULT_ENTITY_AUTHOR } from 'domain/shared/core/constants';
import { EntityHeader } from 'framework/ui/layout';

const AccountingCycleHeader = () => {
  return <EntityHeader entityTitle={data => data.getValueBySource('id')} defaultAuthor={DEFAULT_ENTITY_AUTHOR} />;
};

export default AccountingCycleHeader;
